var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaKatze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#3f505c;}.cls-3{fill:#324049;}.cls-4{fill:#505f69;}.cls-5{fill:#ebebf0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Katze"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.75,87.46,56,87.44l-8.15,58.91A5,5,0,0,0,52.79,152H101a5,5,0,0,0,4.92-5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.73,96.79a47,47,0,0,0,44.31,0l-1.29-9.33L56,87.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.27,25.37,110.59,9a3.53,3.53,0,0,1,6,2.49V55.16C116.61,41,105.41,32.4,94.27,25.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.61,55.16a39.73,39.73,0,1,1-79.45,0c0-21.94,17.78-37.24,39.73-37.24S116.61,33.22,116.61,55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.5,55.16C59.5,36,70.48,22,85.1,18.67a45.17,45.17,0,0,0-8.21-.75,43.09,43.09,0,0,0-20,4.81L43.18,9a3.53,3.53,0,0,0-6,2.49V55.16h0A39.72,39.72,0,0,0,85.1,94C70.48,90.24,59.5,74.28,59.5,55.16Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 68.19,
    cy: 72.54,
    rx: 8.69,
    ry: 7.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 85.58,
    cy: 72.54,
    rx: 8.69,
    ry: 7.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.89,
    cy: 67.58,
    r: 4.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.26,124.48a2.48,2.48,0,1,0-5,.41l.47,5.65a12.93,12.93,0,0,1-12.89,14h0a12.94,12.94,0,0,1-12.9-14l.47-5.65a2.48,2.48,0,0,0-4.95-.41L57.22,152H96.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62,57.65a2.49,2.49,0,0,1-2.49-2.49V52.68a2.49,2.49,0,0,1,5,0v2.48A2.49,2.49,0,0,1,62,57.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.78,57.65a2.49,2.49,0,0,1-2.48-2.49V52.68a2.49,2.49,0,0,1,5,0v2.48A2.49,2.49,0,0,1,91.78,57.65Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaKatze);
export default __webpack_public_path__ + "static/media/ka_katze.a715077be354bef6aba08baa618714c7.svg";
export { ForwardRef as ReactComponent };